export default __webpack_public_path__ + "static/media/heartear.f40e2827.jpg";